import { Component, OnInit } from '@angular/core';
import { UserService } from '../../../services/user.service';
import { Router } from '@angular/router';
import { AuthenticationService } from '../../../services/authentication.service';
import { tap } from 'rxjs';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss'],
})
export class LoginComponent implements OnInit {
  form!: FormGroup;

  constructor(
    private userserv: AuthenticationService,
    private router: Router,
    private fb: FormBuilder
  ) {
    this.form = this.fb.group({
      email: ['', Validators.required],
      password: ['', Validators.required],
    });
  }

  ngOnInit(): void {
    if (localStorage.getItem('idnumber') != null) {
      this.router.navigate(['dashboard']);
    }
  }

  onSubmit() {
    const formData = this.form.value;
    // Handle form submission, e.g., send data to the server
    console.log(formData);

    this.userserv
      .login({ email: formData.email, password: formData.password })
      .subscribe((res) => {
        if (res.flag == 1) {
          this.router.navigate(['dashboard']);
        } else {
          Swal.fire({
            icon: 'warning',
            title: 'NOTICE',
            text: res.message,
            showConfirmButton: false,
            timer: 1500,
          });
        }
      });
  }
}
